<template>
    <div>
        <h1>Welkom bij de plain SQL oefeningen</h1>
        <p>Hier ga je aan de gang met het oefenen van sql query's op de mysql database.</p>
        <p>Klik hier op de Landstede login knop en ga bezig met de opdrachten.</p>
        <button @click="AuthProvider('azure')">Landstede login</button>
    </div>
</template>

<script>
    import Vue from 'vue'; // es6 syntax
    window.Vue = Vue;
    import VueAxios from 'vue-axios'
    import axios from 'axios';
    import VueAuthenticate from 'vue-social-auth'
    import {store} from '../imports/store';
    Vue.use(VueAxios, axios)
    Vue.use(VueAuthenticate, {
        baseUrl: 'https://sql.newdeveloper.nl', // Your API domain
        providers: {
            azure: {
                clientId: 'ba25e104-c884-4962-bfbb-ff33442f4d46',
		url: '/auth/azure',
                display: 'popup',
                tokenPath: 'access_token',
                popupOptions: { width: 500, height: 560 },
                redirectUri: 'https://sql.newdeveloper.nl/api/OAuthCallback', // Your client app URL
                oauthType: '2.0',
                authorizationEndpoint: 'https://login.microsoftonline.com/e8e5eb49-74bd-45b9-905a-1193cb5a9913/oauth2/authorize'
            },
        }
    })
    export default {
        data(){
            return {
                bearrer : localStorage.getItem('user-token') || null
            }
        },
        methods: {
            AuthProvider(provider) {

                var self = this;
               // if (this.bearrer == 'test') {
                    this.$auth.authenticate(provider).then(response => {
                        self.SocialLogin(provider, response)
                    }).catch(err => {
                        console.log({err: err})
                    })
                //}

            },

            SocialLogin(provider,response){
                this.$http.post('/sociallogin/'+provider,response).then(response => {
                    const email = response.data.email;
                    this.bearrer = response.data.bearrer;
                    this.$parent.$data.bearrer = response.data.bearrer;
                    localStorage.setItem('username',response.data.username);
                    let name = response.data.username;
                    let isTeacher = email.includes('@landstede.nl');
                    store.dispatch('setLoginName',{name});
                    store.dispatch('setIsTeacher',{isTeacher});
                    localStorage.setItem('isTeacher',isTeacher);
                    localStorage.setItem('user-token', response.data.bearrer);
                    this.$router.push('/sql_les');

                }).catch(err => {
                    console.log({err:err})
                })
            },
        }
    }
</script>

<style scoped>
    div{
        width: 90%;
        color:white;
        text-align: center;
        background-color: #0c4361;
        align-items: center;
        padding: 10px;

        margin-left: auto;
        margin-right: auto;

    }
  button {
      width: 80%;
      margin-bottom: 10px;
      height: 30px;
      font-size: large;
      color:white;
      background-color: #3490dc;
      border: grey;
      box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6);

  }
</style>
